var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9043 14V10H34.9043V6H38.9043V2H42.9043V6H46.9043V10H42.9043V14H38.9043ZM22.9043 35C25.4043 35 27.5296 34.1253 29.2803 32.376C31.031 30.6267 31.9056 28.5013 31.9043 26C31.9043 23.5 31.0296 21.3753 29.2803 19.626C27.531 17.8767 25.4056 17.0013 22.9043 17C20.4043 17 18.2796 17.8753 16.5303 19.626C14.781 21.3767 13.9056 23.5013 13.9043 26C13.9043 28.5 14.7796 30.6253 16.5303 32.376C18.281 34.1267 20.4056 35.0013 22.9043 35ZM22.9043 31C21.5043 31 20.321 30.5167 19.3543 29.55C18.3876 28.5833 17.9043 27.4 17.9043 26C17.9043 24.6 18.3876 23.4167 19.3543 22.45C20.321 21.4833 21.5043 21 22.9043 21C24.3043 21 25.4876 21.4833 26.4543 22.45C27.421 23.4167 27.9043 24.6 27.9043 26C27.9043 27.4 27.421 28.5833 26.4543 29.55C25.4876 30.5167 24.3043 31 22.9043 31ZM6.9043 42C5.8043 42 4.86296 41.6087 4.0803 40.826C3.29763 40.0433 2.90563 39.1013 2.9043 38V14C2.9043 12.9 3.2963 11.9587 4.0803 11.176C4.8643 10.3933 5.80563 10.0013 6.9043 10H13.2043L16.9043 6H30.9043V14H34.9043V18H42.9043V38C42.9043 39.1 42.513 40.042 41.7303 40.826C40.9476 41.61 40.0056 42.0013 38.9043 42H6.9043Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPhoto);
export default __webpack_public_path__ + "static/media/DownloadPhoto.c457132fe3f04d30e5a9d5f047a997ff.svg";
export { ForwardRef as ReactComponent };